export const message = {
  GENERIC_ERROR: "Oops! Something went wrong",
  OUTDATED_DATA:
    "The data displayed below might be outdated. Click 'Refresh' to update.",

  LOAD_CARD_ISSUERS: "Load card issuers",
  GET_CARD_ISSUER: "Get card issuer",
  EDIT_CARD_ISSUER: "Edit card issuer",
  ADD_CARD_ISSUER: "Add card issuer",

  LOAD_CARD_SCHEMES: "Load card schemes",
  GET_CARD_SCHEME: "Get card scheme",
  EDIT_CARD_SCHEME: "Edit card scheme",
  ADD_CARD_SCHEME: "Add card scheme",

  LOAD_CARD_TYPES: "Load card types",
  GET_CARD_TYPE: "Get card type",
  EDIT_CARD_TYPE: "Edit card type",
  ADD_CARD_TYPE: "Add card type",

  LOAD_CLIENTS: "Load clients",
  GET_CLIENT: "Get client",
  EDIT_CLIENT: "Edit client",
  ADD_CLIENT: "Add client",

  LOAD_CONFIGS: "Load configurations",
  GET_CONFIG: "Get configuration",
  EDIT_CONFIG: "Edit configuration",
  ADD_CONFIG: "Add configuration",

  LOAD_DOMAINS: "Load domains",
  GET_DOMAIN: "Get domain",
  EDIT_DOMAIN: "Edit domain",
  ADD_DOMAIN: "Add domain",

  LOAD_CURRENCIES: "Load currencies",
  GET_CURRENCY: "Get currency",
  EDIT_CURRENCY: "Edit currency",
  ADD_CURRENCY: "Add currency",

  LOAD_IDTYPES: "Load identification types",
  GET_IDTYPE: "Get identification type",
  EDIT_IDTYPE: "Edit identification type",
  ADD_IDTYPE: "Add identification type",

  LOAD_INSTITUTIONS: "Load institutions",
  GET_INSTITUTION: "Get institution",
  EDIT_INSTITUTION: "Edit institution",
  ADD_INSTITUTION: "Add institution",

  LOAD_CORE_DOMAINS: "Load core domains",
  LOAD_CORE_ISSUERS: "Load core issuers",
  LOAD_CORE_CURRENCIES: "Load core currencies",
  LOAD_CARD_STATUS: "Load card status"
};
